import React, { useState } from 'react';
import NavbarLeft from './NavbarLeft';
import GroupIcon from '@material-ui/icons/Group';
import HomeIcon from '@material-ui/icons/Home';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import CasinoIcon from '@material-ui/icons/Casino';
import StorefrontIcon from '@material-ui/icons/Storefront';
import logo from '../image/facebook-brands.svg';
import './Header.css';
import { Avatar, Badge, Divider,  List, Menu, MenuItem, Tooltip } from '@material-ui/core';
import { Icon } from 'semantic-ui-react'; 
import { makeStyles } from '@material-ui/core/styles';
import NotificationsIcon from '@material-ui/icons/Notifications';
import {  grey  } from '@material-ui/core/colors';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Link } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import AnnouncementIcon from '@material-ui/icons/Announcement';
 import SettingsIcon from '@material-ui/icons/Settings';
 import HelpIcon from '@material-ui/icons/Help';
 import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import AppsIcon from '@material-ui/icons/Apps';
import { auth} from '../Auth/FirebaseConfig';
import { useHistory } from 'react-router';





const Navbar = ({user}) => {
 

  const [anchorEl, setAnchorEl] = useState(null);
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const history = useHistory("");
  const logout = () => {
    if (user) {
      auth.signOut();
      history.push("/login");
    } 
  }
  const useStyles2 = makeStyles((theme) => ({
    root: {
      width: '100%',
      maxWidth: 300,
      maxHeight: 400,
      backgroundColor: theme.palette.background.paper,
    },
  }));
  const menuId = 'primary-search-account-menu';
  const isMenuOpen = Boolean(anchorEl);
  const classes2 = useStyles2();
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}>

      <List className={classes2.root}>
        <MenuItem onClick={handleMenuClose}>
            <ListItem>
            <ListItemAvatar> 
                <Avatar src={user?.photoURL}/>  
            </ListItemAvatar>
            <ListItemText primary={user?.displayName} secondary="See your Profile" onClick={handleMenuClose}/>
            </ListItem>
        </MenuItem> 
            <Divider variant="inset" component="li" />
        <MenuItem onClick={handleMenuClose}>
        <ListItem>
        <ListItemAvatar>
            <Avatar><AnnouncementIcon/></Avatar>
        </ListItemAvatar>
        <ListItemText primary="Give Feedback" secondary="Help Us Improve The New Facebook" />
        </ListItem>
            </MenuItem>
        <Divider variant="inset" component="li" />
            <MenuItem onClick={handleMenuClose}>
                <ListItem>
                <ListItemAvatar>
                    <Avatar><SettingsIcon/></Avatar>
                </ListItemAvatar>
                <ListItemText primary="Settings & Privacy" /><ArrowRightIcon/>
                </ListItem>
            </MenuItem> 
        <MenuItem onClick={handleMenuClose}>
            <ListItem>
            <ListItemAvatar>
                    <Avatar> <HelpIcon />  </Avatar>
                </ListItemAvatar>
            <ListItemText primary="Help &Support" onClick={handleMenuClose}/><ArrowRightIcon/>
            </ListItem>
        </MenuItem> 
            <MenuItem onClick={handleMenuClose}>
            <ListItem>
            <ListItemAvatar>
                <Avatar> <FontAwesomeIcon icon={faMoon} /> </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Display & Accessibility" onClick={handleMenuClose}/><ArrowRightIcon/>
            </ListItem>
        </MenuItem> 
        <MenuItem onClick={handleMenuClose}>
          <ListItem>
          <ListItemAvatar>
              <Avatar>  <FontAwesomeIcon icon={faSignOutAlt} /> </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Log Out" onClick={logout}/>
          </ListItem>
        </MenuItem> 
        </List>
        </Menu>
  );


    return (
        <div>
        <nav className="nav fixed-top">
        <Link to="/"> <img src={logo} alt="" height="45px" width="45px"  className="ml-2 mt-2"/></Link>
        <NavbarLeft />
        <div className="navOption">
         <Icon name="options" size="large" />
        </div>
    
 
        <div className="navMiddle">
          <li className="active icon" >
            <Link className="nav-link" to="/home">
              <HomeIcon fontSize="large" style={{ color: grey[600] }} /><span className="title">Home</span>
            </Link> 
          </li>
          <li className="icon" >
            <Link className="nav-link" to="/watch">
            <OndemandVideoIcon  fontSize="large" style={{ color: grey[600] }}/><span className="title2 ">Watch</span>
            </Link>
          </li> 
            <li className="icon" >
            <Link className="nav-link" to="/marketplace">
            <StorefrontIcon fontSize="large" style={{ color: grey[600] }}/><span className="title3">Marketplace</span>
            </Link>
          </li>
          <li className="icon">
            <Link className="nav-link" to="/groups">
            <GroupIcon fontSize="large" style={{ color: grey[600] }}/><span className="title4">Groups</span>
            </Link>
          </li>
          <li className="icon" >
          <Link className="nav-link" to="/games">
          <CasinoIcon fontSize="large" style={{ color: grey[600] }}/><span className="title5">Gaming</span>
          </Link>
        </li>
      </div> 
          
        <div className="navRight d-flex" >
        <div className="pro">
        <Link to={`/${user.displayName}`} className="d-flex">
          <Avatar  src={user.photoURL}/> 
          <h5 className='mt-3 ml-2 proName' onClick={() => {window.location.href=  `/${user.displayName}`}}>{user.displayName}</h5>
        </Link>
        </div>      
        <li className="nav-item" >
         <Link className="nav-link" to="/">
          <Tooltip title="Add"><AppsIcon style={{ color: grey[600] }} fontSize="large" className="rtIcon"/></Tooltip>
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/">
          <Badge badgeContent={11} color="secondary" >
          <Tooltip title="Messenger"><Icon name='facebook messenger' size="big" className="rtIcon"/></Tooltip>
          </Badge>
          </Link>
        </li>
        <li className="nav-item" >
          <Link className="nav-link" to="/">
          <Badge badgeContent={11} color="secondary" >
          <Tooltip title="Notifications"><NotificationsIcon fontSize="large" className="rtIcon"/></Tooltip>
          </Badge>
        </Link>
        </li>
        <li className="nav-item" >
          <Link className="nav-link" to="/">
          <Tooltip title="Account">
            <ExpandMoreIcon fontSize="large" className="rtIcon" aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}/>
          </Tooltip>
          </Link>
        </li>
      </div>
      </nav>
      {renderMenu}
        </div>
    );
};

export default Navbar;